import Axios from "axios";
import { getToken } from "./authService";
import ENUMS from "../utils/ENUMS";
import { BASE_URL } from "../config.json";

const { API_MSG } = ENUMS;

let requestHistory = [];

export const getAxiosAuthHeader = () => {
  const token = getToken();
  if (!token) return {};
  return {
    Authorization: "Bearer " + token,
  };
};

const axios = Axios.create({
  baseURL: BASE_URL,
  headers: getAxiosAuthHeader(),
});

// Request interceptors (avoiding ongoing concurrent requests for two similar endpoints)
axios.interceptors.request.use((config) => {
  // Do something before request is sent

  // If cancel token is disabled manually
  if (config.hasOwnProperty("cancelToken") && config["cancelToken"] === false)
    return config;

  // Adding cancel token dynamically
  const source = Axios.CancelToken.source();
  config["cancelToken"] = source.token;

  const reqUrl = config.url.split("?")[0];

  const reqData = {
    ...config,
    metaData: {
      source,
      url: reqUrl,
      timestamp: new Date().valueOf(),
    },
  };
  const existingReq = requestHistory.find(
    (req) => req.method === config.method && req.metaData.url === reqUrl
  );
  if (existingReq) {
    // Cancelling the old request
    existingReq.metaData.source.cancel(API_MSG.CANCELLED);
    requestHistory = requestHistory.filter((req) => req !== existingReq);
  }

  requestHistory.push(reqData);
  return config;
});

// Handling unexpected response error messages globally
axios.interceptors.response.use(null, (error) => {
  const errorDetails = error.response;

  if (
    errorDetails &&
    errorDetails.config.method === "get" &&
    errorDetails.status === 404
  ) {
    // Redirect to 404
    // return window.location.replace('/404')
  }

  return Promise.reject(error);
});

const httpService = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  patch: axios.patch,
  delete: axios.delete,
};

export default httpService;
